<template>
  <mdb-container id="container" fluid>
    <mdb-row class="fluid">
      <FilteredItemsList @changed="updateCountryList()" />
    </mdb-row>

    <mdb-row class="no-print"
      ><mdb-col xs="12" md="6" offsetMd="3" lg="3" offsetLg="4"
        ><SearchWithAutoComp @changed="updateCountryList()"/></mdb-col
    ></mdb-row>

    <mdb-row>
      <mdb-col lg="10"><CoverageMap id="top"></CoverageMap></mdb-col>

      <mdb-col lg="2" class="no-print"
        ><LegendBox
          :isFixed="scrolledDown"
          class="sticky-legend z-index-2000 "
        ></LegendBox>
      </mdb-col>
    </mdb-row>
    <hr class="no-print" />
    <mdb-row class="no-print">
      <mdb-col sm="6" md="3" lg="2" offsetLg="2" class="button-margin">
        <dt-model btnName="Filters" btnIcon="filter" title="Filters"
          ><filters @changed="updateCountryList()"></filters
        ></dt-model>
      </mdb-col>
      <mdb-col sm="6" md="3" lg="2" class="button-margin">
        <ZoomByRegion @changed="updateCountryList()" />
      </mdb-col>
      <mdb-col sm="6" md="3" lg="2" class="button-margin">
        <button @click="print()" class="dt-btn-primary" size="sm">
          Export as PDF <mdb-icon icon="file-export" /></button
      ></mdb-col>
      <mdb-col sm="6" md="3" lg="2" class="button-margin">
        <reset @reset="updateCountryList()"
      /></mdb-col>
    </mdb-row>
    <hr />
    <mdb-row>
      <mdb-col offsetSm="1" sm="10"
        ><CountriesList ref="countriesList"
      /></mdb-col>
      <mdb-col sm="1">
        <button
          v-if="scrolledDown"
          class="scroll-up no-print"
          title="scroll up to the top"
          @click="scrollUp()"
        >
          <i class="fas fa-angle-double-up"></i></button></mdb-col
    ></mdb-row>
  </mdb-container>
</template>
<script>
import CoverageMap from "../components/CoverageMap.vue";
import Filters from "../components/Filters.vue";
import CountriesList from "../components/CountriesList.vue";
import DtModel from "../components/DtModel.vue";
import SearchWithAutoComp from "../components/SearchWithAutoComp.vue";
import ZoomByRegion from "../components/ZoomByRegion.vue";
import Reset from "../components/Reset.vue";
import LegendBox from "../components/LegendBox.vue";
import FilteredItemsList from "../components/FilteredItemsList.vue";
import { getServices } from "../common/dataSourceIntegrationService";

export default {
  name: "RxMap",
  data() {
    return {
      scrolledDown: false
    };
  },
  created() {
    if (Object.keys(getServices()).length == 0) {
      this.$router.push({ name: "notFound" });
    }
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    updateCountryList() {
      this.$refs.countriesList.update();
    },
    print() {
      window.print();
    },
    handleScroll() {
      this.scrolledDown = window.scrollY > 400;
    },
    scrollUp() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0;
    }
  },

  components: {
    CoverageMap,
    Filters,
    CountriesList,
    DtModel,
    SearchWithAutoComp,
    ZoomByRegion,
    Reset,
    LegendBox,
    FilteredItemsList
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.scroll-up {
  color: white;
  border-style: None;
  border-radius: 20px;
  background: #5586ab;
  position: fixed;
  right: 0.5%;
  padding: 0.5rem;
  bottom: 40%;

  &:hover {
    box-shadow: none;
    outline: none;
    border-color: #69be29;
    background: #fff;
    color: #69be29;
  }
}
.button-margin {
  margin-bottom: 5px;
  .container-fluid {
    padding: 0;
  }
}
.sticky-legend {
  position: sticky;
  top: 0;
}
.fluid {
  background-color: #f0f3f5;
  border-bottom: 1px solid #e1e7eb;
}
.btn-filter {
  margin: 10px 0;
  .container-fluid {
    padding: 0;
  }
}
button.dt-btn-primary{    
  min-width: 170px!important;
  max-width: 240px;
}
.dropdown, button.dt-btn-primary{ 
  width: 100%;
}
.tt_sm {
  .tt_name_sm {
    color: #5586ab;
    font-weight: normal;
    font-size: 1.6em;
    text-align: center;
    width: 100%;
    padding-top: 5px;
  }
  .xmark_sm {
    position: absolute;
    right: 10px;
    top: 10px;
    opacity: .5;
    &:hover {
      opacity: 1;
    }
  }
  .btn_simplemaps {
    background: #5586ab;    
    color: #fff!important;
    border: none;
    text-transform: uppercase;
    letter-spacing: 1px;
    font: bold 1em/32px 'Open Sans', sans-serif;
    height: 40px;
  }
}
.modal .modal-dialog.modal-top {
  right: 0;
  bottom: 0;
  .modal-content {
    height: 100vh;
    max-height: 100vh;
  }
}
</style>
